import { render } from "./ImageCollageEditModal.vue?vue&type=template&id=38e3840e&scoped=true"
import script from "./ImageCollageEditModal.vue?vue&type=script&lang=js"
export * from "./ImageCollageEditModal.vue?vue&type=script&lang=js"

import "./ImageCollageEditModal.vue?vue&type=style&index=0&id=38e3840e&scoped=true&lang=less"
import "./ImageCollageEditModal.vue?vue&type=style&index=1&id=38e3840e&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e3840e"]])

export default __exports__